import React from "react";
import { Link } from "react-router-dom";
import { useArticles } from '../../hooks/useAirtableArticles';

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const BlogSection = (props) => {
    const { articles, loading, error } = useArticles(4, true);

    if (loading) {
        return (
            <section className={"" + props.tClass}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-9 col-12">
                            <div className="section_title">
                                <h3>Latest Medical Insights</h3>
                                <p style={{textAlign: "center"}}>Stay informed with Dr. Pereira&apos;s expertise on cutting-edge regenerative medicine research and breakthrough treatments</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 text-center">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading articles...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (error || !articles || articles.length === 0) {
        return (
            <section className={"" + props.tClass}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-9 col-12">
                            <div className="section_title">
                                <h3>Latest Medical Insights</h3>
                                <p style={{textAlign: "center"}}>Stay informed with Dr. Pereira&apos;s expertise on cutting-edge regenerative medicine research and breakthrough treatments</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 text-center">
                            <p>Our medical insights blog is being updated. Please check back soon for the latest articles.</p>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    const featuredArticle = articles[0];
    const recommendedArticles = articles.slice(1, 4);

    return (
        <section className={"blog_section " + props.tClass}>
            <div className="container">
                {/* Title */}
                <div className="row justify-content-center">
                    <div className="col-lg-9 col-12 mb-5">
                        <div className="section_title">
                            <h3>Latest Medical Insights</h3>
                            <p style={{textAlign: "center"}}>
                                Stay informed with Dr. Pereira&apos;s expertise on cutting-edge regenerative medicine research and breakthrough treatments
                            </p>
                        </div>
                    </div>
                </div>

                {/* Featured Article */}
                <div className="featured-article-wrapper" style={{marginBottom: '60px'}}>
                    <div className="featured-article-card" style={{
                        background: '#fff',
                        borderRadius: '20px',
                        overflow: 'hidden',
                        boxShadow: '0px 5px 30px rgba(18, 47, 105, 0.12)'
                    }}>
                        {/* Image on top */}
                        <div className="featured-image" style={{position: 'relative'}}>
                            {featuredArticle.featuredImage && (
                                <img
                                    src={featuredArticle.featuredImage}
                                    alt={featuredArticle.title}
                                    style={{
                                        width: '100%',
                                        height: '400px',
                                        objectFit: 'cover'
                                    }}
                                />
                            )}
                        </div>
                        {/* Content below */}
                        <div className="featured-content" style={{
                            padding: '40px'
                        }}>
                            {/* Date / Categories */}
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                                marginBottom: '20px',
                                fontSize: '14px',
                                color: '#D3AF37',
                                fontWeight: '500',
                                flexWrap: 'wrap'
                            }}>
                                <span>
                                    {new Date(featuredArticle.publishedDate || Date.now()).toLocaleDateString('en-US', {
                                        month: 'short',
                                        day: 'numeric',
                                        year: 'numeric'
                                    })}
                                </span>
                                <span>/</span>
                                {Array.isArray(featuredArticle.category)
                                    ? featuredArticle.category.join(' • ')
                                    : (featuredArticle.category || 'Medical Research')
                                }
                            </div>

                            {/* Article Title */}
                            <h3 style={{
                                fontSize: '36px',
                                color: '#0B9FFE',
                                fontWeight: '600',
                                marginBottom: '20px',
                                lineHeight: '1.3'
                            }}>
                                {featuredArticle.title}
                            </h3>

                            {/* Summary */}
                            {(featuredArticle.excerpt || featuredArticle.subtitle) && (
                                <p style={{
                                    fontSize: '17px',
                                    lineHeight: '1.7',
                                    color: '#666',
                                    marginBottom: '30px'
                                }}>
                                    {featuredArticle.excerpt || featuredArticle.subtitle}
                                </p>
                            )}

                            {/* Button */}
                            <Link
                                onClick={ClickHandler}
                                to={`/blog/${featuredArticle.slug}`}
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    background: '#D3AF37',
                                    color: '#fff',
                                    padding: '12px 28px',
                                    borderRadius: '25px',
                                    textDecoration: 'none',
                                    fontSize: '15px',
                                    fontWeight: '500',
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                <i className="fa fa-arrow-right"></i>
                                <span>Read Full Article</span>
                            </Link>
                        </div>
                    </div>
                </div>

                {/* Recommended Section */}
                {recommendedArticles.length > 0 && (
                    <>
                        <div className="row">
                            <div className="col-12">
                                <h3 style={{
                                    fontSize: '32px',
                                    color: '#0B9FFE',
                                    fontWeight: '600',
                                    marginBottom: '40px'
                                }}>
                                    Recommended
                                </h3>
                            </div>
                        </div>
                        <div className="row">
                            {recommendedArticles.map((article) => (
                                <div className="col-lg-4 col-md-6 col-12" key={article.id} style={{
                                    marginBottom: '30px',
                                    display: 'flex'
                                }}>
                                    <Link
                                        onClick={ClickHandler}
                                        to={`/blog/${article.slug}`}
                                        style={{
                                            textDecoration: 'none',
                                            width: '100%',
                                            display: 'flex'
                                        }}
                                    >
                                        <div className="recommended-card" style={{
                                            background: '#fff',
                                            borderRadius: '20px',
                                            overflow: 'hidden',
                                            boxShadow: '0px 4px 20px rgba(18, 47, 105, 0.08)',
                                            transition: 'all 0.3s ease',
                                            cursor: 'pointer',
                                            width: '100%',
                                            display: 'flex',
                                            flexDirection: 'column'
                                        }}>
                                            {/* Image on top */}
                                            <div className="card-image-wrapper" style={{
                                                flexShrink: 0
                                            }}>
                                                {article.featuredImage && (
                                                    <img
                                                        src={article.featuredImage}
                                                        alt={article.title}
                                                        style={{
                                                            width: '100%',
                                                            height: '240px',
                                                            objectFit: 'cover'
                                                        }}
                                                    />
                                                )}
                                            </div>
                                            {/* Title below */}
                                            <div className="card-content" style={{
                                                padding: '25px',
                                                flex: '1',
                                                display: 'flex',
                                                alignItems: 'flex-start'
                                            }}>
                                                <h3 style={{
                                                    fontSize: '22px',
                                                    color: '#0B9FFE',
                                                    fontWeight: '600',
                                                    marginBottom: '0',
                                                    lineHeight: '1.4'
                                                }}>
                                                    {article.title}
                                                </h3>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </div>
        </section>
    );
}

export default BlogSection;
